<div class="field is-horizontal mb-2">
    <div class="field-label field-label-tooltip">
        <label [for]="id" class="has-text-primary has-text-weight-bold">
            {{ label }}<span class="has-text-danger" *ngIf="mandatory">&nbsp;*</span>
        </label>
        <isav-tooltip-display [tooltipKey]="tooltipKey"></isav-tooltip-display>
    </div>
    <div class="field-body">
        <div class="field">
            <div class="control">
                <input
                    type="datetime-local"
                    placeholder="YYYY-MM-DDThh:mm:ss"
                    [id]="id"
                    class="input"
                    [value]="value"
                    [readonly]="disabled"
                    (input)="onChange($event.target.value)"
                    (focus)="onFocus()"
                    (blur)="correctValue()"
                />
            </div>
            <p *ngIf="!SUPPORTS_NATIVE_DATETIME_LOCAL" class="help">
                Format of date time: YYYY-MM-DDThh:mm:ss, eg: {{ EXAMPLE_DATE }}
            </p>
        </div>
    </div>
</div>
